import { FusionSettingsApi } from "../../client-fusion";
import { APIOptionsWithoutAPIClass, useAPI } from "./useAPI";

export const useFusionSettingsAPI = <T>({
  initialValue,
  handleRequest,
}: APIOptionsWithoutAPIClass<T, FusionSettingsApi>) => {
  return useAPI<T, FusionSettingsApi>({
    initialValue,
    APIClass: FusionSettingsApi,
    handleRequest,
  });
};
